var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('router-link',_vm._b({},'router-link',_vm.$attrs,false),[_vm._t("default")],2):_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }